'use client';
import { useFilter } from '@/src/hooks/use-filter';
import { useRouter } from 'next/navigation';
import FilterFacetPanel from '../pos/listing/filter-facet-panel';
import { Pages } from '@/src/interfaces/pages-route';

export const CreditCardFilter = ({
  facets,
  sortingComponent,
}: {
  facets: Pages.CreditcardListCreate.ResponseBody['facets'][];
  sortingComponent?: React.ReactNode;
}) => {
  const router = useRouter();

  const handleFilterSubmit = (data: any) => {
    if (!data.Bank) {
      router.push(`/ticari-kart`);
    } else {
      const query = new URLSearchParams();
      data.Bank.forEach((bankId: string) => {
        query.append('Bank', bankId);
      });

      router.push(`?${query.toString()}`);
    }
  };

  const { register, getValues, setValue, resetAndSubmit, selectedFilterCount, onSubmitHandler } = useFilter({
    facets,
    watchedFields: ['Bank'],
    onSubmit: handleFilterSubmit,
  });

  return (
    <FilterFacetPanel
      sortingComponent={sortingComponent}
      // reset={reset}
      resetAndSubmit={resetAndSubmit}
      facets={facets}
      handleSubmit={onSubmitHandler}
      // watchedValues={watchedValues}
      register={register}
      getValues={getValues}
      setValue={setValue}
      selectedFilterCount={selectedFilterCount}
    />
  );
};
